<div [ngSwitch]="field.variant">
  <!-- Text Input -->
  <input *ngSwitchCase="'text'" pInputText type="text" [placeholder]="field.props?.['placeholder'] || '' | translate"
    [disabled]="!!(field.isDisabled | async)" [class.w-full]="true" [class.ng-invalid]="field.error | async"
    [class.ng-dirty]="field.error | async" [ngModel]="field.props?.['value'] | async"
    (ngModelChange)="field.props?.['onChange']($event)" (blur)="field.props?.['onBlur'] && field.props?.['onBlur']()" />

  <!-- Tel Input -->
  <input *ngSwitchCase="'tel'" pInputText type="tel" [placeholder]="field.props?.['placeholder'] || '' | translate"
    [disabled]="!!(field.isDisabled | async)" [class.w-full]="true" [class.ng-invalid]="!!(field.error | async)"
    [class.ng-dirty]="!!(field.error | async)" (keypress)="allowOnlyPhoneCharacters($event)"
    [ngModel]="field.props?.['value'] | async" (ngModelChange)="field.props?.['onChange']($event)"
    (blur)="field.props?.['onBlur'] && field.props?.['onBlur']()" />

  <!-- Email Input -->
  <input *ngSwitchCase="'email'" pInputText type="email" [placeholder]="field.props?.['placeholder'] || '' | translate"
    [disabled]="!!(field.isDisabled | async)" [class.w-full]="true" [class.ng-invalid]="!!(field.error | async)"
    [class.ng-dirty]="!!(field.error | async)" [ngModel]="field.props?.['value'] | async"
    (ngModelChange)="field.props?.['onChange']($event)" (blur)="field.props?.['onBlur'] && field.props?.['onBlur']()" />

  <!-- Password Input -->

  <div *ngSwitchCase="'password'">
    <p-password fluid [disabled]="!!(field.isDisabled | async)" [class.ng-invalid]="!!(field.error | async)"
      [class.ng-dirty]="!!(field.error | async)" [toggleMask]="true" [feedback]="false"
      [ngModel]="field.props?.['value'] | async" (ngModelChange)="onChangeHandler(field, $event)"
      (onBlur)="field.props?.['onBlur'] && field.props?.['onBlur']()" />
    <p class="pt-2 text-red-500 font-extrabold underline" *ngIf="field.props?.['message']">{{ field.props?.['message'] |
      translate }}
    </p>
  </div>

  <!-- Number Input -->
  <p-inputnumber *ngSwitchCase="'number'" [class.w-full]="true"
    [placeholder]="field.props?.['placeholder'] || '' | translate" [disabled]="!!(field.isDisabled | async)"
    [class.ng-invalid]="!!(field.error | async)" [class.ng-dirty]="!!(field.error | async)"
    [ngModel]="field.props?.['value'] | async" (ngModelChange)="field.props?.['onChange']($event)"
    [attr.mode]="field.props?.['mode']" [max]="field.props?.['max']" [min]="field.props?.['min']"
    [minFractionDigits]="field.props?.['minFractionDigits'] || 0"
    [maxFractionDigits]="field.props?.['maxFractionDigits'] || 0"></p-inputnumber>

  <!-- Date Input -->
  <p-datepicker *ngSwitchCase="'date'" fluid [dateFormat]="field.props?.['format'] || 'dd/mm/yy'" appendTo="body"
    [placeholder]="field.props?.['placeholder'] || '' | translate" [view]="field.props?.['view'] || 'date'"
    [disabled]="!!(field.isDisabled | async)" [class.w-full]="true" [class.ng-invalid]="!!(field.error | async)"
    [class.ng-dirty]="!!(field.error | async)" [showIcon]="true" [minDate]="field.props?.['minDate']"
    [maxDate]="field.props?.['lastDate']" [showTime]="field.props?.['showTime'] || false" hourFormat="24"
    [showButtonBar]="true" [ngModel]="field.props?.['value'] | async"
    (ngModelChange)="field.props?.['onChange']($event)"></p-datepicker>

  <!-- Textarea Input -->
  <textarea *ngSwitchCase="'textarea'" pTextarea [placeholder]="field.props?.['placeholder'] || '' | translate"
    [disabled]="!!(field.isDisabled | async)" [class.w-full]="true" [class.ng-invalid]="!!(field.error | async)"
    [class.ng-dirty]="!!(field.error | async)" [class.resize-none]="field.props?.['resize'] === 'none'"
    [disabled]="!!(field.isDisabled | async)" [cols]="field.props?.['cols']" [rows]="field.props?.['rows']"
    [ngModel]="field.props?.['value'] | async" (ngModelChange)="field.props?.['onChange']($event)"></textarea>

  <!-- Select Input -->
  <p-select *ngSwitchCase="'select'" [class.w-full]="true" [class.ng-invalid]="!!(field.error | async)"
    [class.ng-dirty]="!!(field.error | async)" [filter]="field.props?.['filterEnabled']"
    [filterBy]="this.containsSearchableOption() ? 'searchable' : 'name'" [showClear]="field.props?.['showClear']"
    optionLabel="name" dataKey="code" appendTo="body" [emptyMessage]="'common.noDataFound' | translate"
    [disabled]="!!(field.isDisabled | async)" [placeholder]="field.props?.['placeholder'] || '' | translate"
    [options]="(options$ | async) ?? []" [ngModel]="field.props?.['value'] | async"
    (ngModelChange)="field.props?.['onSelectChange']($event)"
    (onBlur)="field.props?.['onBlur'] && field.props?.['onBlur']()" />

  <!-- MultiSelect Input -->
  <p-multiselect *ngSwitchCase="'multiselect'" [options]="(options$ | async) ?? []"
    [optionLabel]="field.props?.['optionLabel'] || 'name'" [filter]="true"
    [filterBy]="containsSearchableOption() ? 'searchable' : 'name'" [filterPlaceHolder]="'common.search' | translate"
    fluid dataKey="code" appendTo="body" [disabled]="!!(field.isDisabled | async)"
    [placeholder]="field.props?.['placeholder'] || '' | translate" [ngModel]="field.props?.['value'] | async"
    (ngModelChange)="field.props?.['onSelectChange']($event)" [emptyFilterMessage]="'common.noDataFound' | translate"
    [emptyMessage]="'common.noDataFound' | translate" [selectedItemsLabel]="'common.selectedItems' | translate"
    [showClear]="true" />

  <!-- Checkbox -->
  <div *ngSwitchCase="'checkbox'" [ngClass]="['flex gap-2', field.props?.['breakline'] ? 'flex-col' : 'flex-row']">
    <div *ngFor="let option of field.props?.['options']" class="flex flex-row gap-2 my-1">
      <p-checkbox [binary]="false" [value]="option.code" [ngModel]="field.props?.['values'] | async"
        (ngModelChange)="field.props?.['onCheckChange']($event)">
      </p-checkbox>
      <p>{{ option.name }}</p>
    </div>
  </div>

  <!-- Switch -->
  <div *ngSwitchCase="'switch'" class="flex flex-row gap-4 items-center">
    <p-toggleswitch class="mt-2" [ngModel]="field.props?.['checked'] | async"
      (onChange)="field.props?.['onChange']($event)" [disabled]="!!(field.isDisabled | async)">
    </p-toggleswitch>
    <p class="text-sm text-muted-color">{{ field.props?.['placeholder'] | translate }}</p>
  </div>

  <!-- File Uploader -->
  <div *ngSwitchCase="'file'">
    <sm-file-uploader mode="advanced" customUpload="true" [accept]="field.props?.['accept']" [showUploadButton]="false"
      [disabled]="(field.isDisabled | async) || false" [maxFileSize]="field.props?.['maxFileSize']"
      [multiple]="field.props?.['multiple']" [onFileSelect]="field.props?.['onFileSelect']"
      [onFileRemoved]="field.props?.['onFileRemoved']"
      [onFileRepresentationChange]="field.props?.['onFileRepresentationChange']" [openFile]="field.props?.['openFile']"
      [onFileDownLoad]="field.props?.['onFileDownLoad']" [onAllRemoved]="field.props?.['onAllRemoved']"
      [existingFileHeader]="field.props?.['existingFileHeader'] ?? true"
      [setResetMethod]="field.props?.['setResetMethod']"
      [existingLabel]="field.props?.['existingLabel'] ?? 'common.files.existingFiles'"
      [files]="field.props?.['files']"
      [value]="field.props?.['value']"></sm-file-uploader>
    <p class="pt-2 text-red-500 font-extrabold underline" *ngIf="field.props?.['message']">{{ field.props?.['message'] |
      translate }}
    </p>
  </div>


  <!-- color picker -->
  <div *ngSwitchCase="'color'" class="flex flex-row gap-4 items-center">
    <p-color-picker fluid styleClass="border" [ngModel]="field.props?.['value'] | async"
      (onChange)="field.props?.['onChange']($event)"></p-color-picker>
    {{ field.props?.['value'] | async }}
  </div>

  <!-- Editor Input -->
  <p-editor *ngSwitchCase="'editor'" [readonly]="(field.isDisabled | async) || false" [class.w-full]="true"
    [class.ng-invalid]="!!(field.error | async)" [class.ng-dirty]="!!(field.error | async)"
    [style]="{ height: field.props?.['height'] }" [styleClass]="field.props?.['class']"
    [ngModel]="field.props?.['value'] | async" (ngModelChange)="field.props?.['onChange']?.($event)" />

  <!-- TextGroups -->
  <sm-text-groups *ngSwitchCase="'text-groups'" [singular]="field.props?.['singular']"
    [value]="(field.props?.['value'] | async) || []" [disabled]="(field.isDisabled | async) || false"
    [onChange]="field.props?.['onChange']" [error]="normalizeError(field.error | async)"></sm-text-groups>

  <!-- Button -->
  <p-button *ngSwitchCase="'button'" [styleClass]="field.props?.['class']" [label]="field.props?.['label'] | translate"
    [icon]="field.props?.['icon']" [severity]="field.props?.['severity'] || 'primary'"
    [disabled]="(field.isDisabled | async) || false" (onClick)="field.props?.['onClick']?.()"></p-button>

  <!-- Radio Button -->
  <div *ngSwitchCase="'radio'">
    <div *ngFor="let option of field.props?.['options']" class="flex items-center mb-2">
      <p-radiobutton
        [inputId]="option.code"
        [disabled]="(field.isDisabled | async) || false"
        [name]="field.props?.['name']"
        [value]="option"
        [ngModel]="field.props?.['value'] | async"
        (ngModelChange)="field.props?.['onChange']?.($event)" />
      <label [for]="option.code" class="ml-2">{{ option.name | translate }}</label>
    </div>
  </div>
  <!-- Custom Input -->
  <ng-container *ngSwitchCase="'custom'">
    <ng-template #customComponentContainer></ng-template>
  </ng-container>

  <ng-container *ngSwitchCase="'empty'"></ng-container>

  <!-- Default -->
  <p *ngSwitchDefault class="text-red-500 font-bold">Default (Not supported)</p>
</div>
<div *ngIf="field.error | async as error" class="text-red-500 text-xs mt-1">
  <div *ngFor="let err of normalizeError(error)">{{ err | translate }}</div>
</div>